import { api } from 'utility';
import { getGenerateKeyUrl } from 'URLs';
// Cards
export function generateKey(params) {
  return api.get(getGenerateKeyUrl(), { params }).then((res) => res.data);
}

export default {
  generateKey,
};
